/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Search_ProductHit as SearchProductHit } from '__generated__/graphql-types-do-not-use';

import SearchPlaceHolderWrapper from 'bundles/ent-website/components/CourseSearch/SearchPlaceHolderWrapper';
import SearchResultCard from 'bundles/ent-website/components/CourseSearch/SearchResultCard';

type InputProps = {
  numberOfResults: number;
};

type Props = {
  hits: SearchProductHit[];
  searching: boolean;
} & InputProps;

export const InPageSearchResults = ({ hits = [], searching, numberOfResults }: Props) => {
  const styles = {
    searchResults: css`
      list-style: none;
      padding: 0;

      li {
        width: 100%;
        margin: 0;
        border: none;
        padding: 0;
        border-top: 1px solid var(--cds-color-grey-200);
      }
    `,
  };

  return (
    <div className="rc-AlgoliaSearchResults">
      <SearchPlaceHolderWrapper searching={searching} numberOfResults={numberOfResults}>
        <ul css={styles.searchResults}>
          {hits.map((hit) => (
            <li key={hit?.id}>
              <SearchResultCard hit={hit} />
            </li>
          ))}
        </ul>
      </SearchPlaceHolderWrapper>
    </div>
  );
};

export default React.memo(InPageSearchResults);
